<template>
  <client-only>
    <div
      v-if="shouldDisplayBanner"
      data-test-id="component-generic-banner"
      class="w-full p-4"
      :class="[addonClass, bgClass, small ? 'py-micro' : 'p-4']"
    >
      <slot :close="close" />
    </div>
  </client-only>
</template>

<script>
import { mapState } from 'pinia'
import { applicationStore } from '~/store/application'
export default {
  props: {
    cookieName: {
      type: String,
      required: true
    },
    bgClass: {
      type: String,
      required: false,
      default: () => 'bg-light-green'
    },
    addonClass: {
      type: String,
      required: false,
      default: () => ''
    },
    cookieDuration: {
      type: Number,
      required: false,
      default: () => 31536000
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      displayBanner: false
    }
  },
  computed: {
    ...mapState(applicationStore, {
      isMajorityBrowser: 'isMajorityBrowser'
    }),
    shouldDisplayBanner () {
      return this.displayBanner && !this.isMajorityBrowser
    }
  },
  mounted () {
    this.displayBanner = !this.$cookies.get(this.cookieName)
  },
  methods: {
    close () {
      this.$cookies.set(this.cookieName, true, { maxAge: this.cookieDuration, path: '/' })
      this.displayBanner = false
    }
  }
}
</script>
